import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { NativeClientService } from '@xt/core/native-client';
import { of, switchMap } from 'rxjs';

/**
 * Checks if the user is authenticated and tries to trigger a login if negative
 */
export const isAuthenticatedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthService);
  const nativeClientService = inject(NativeClientService);

  if (nativeClientService.isNative) {
    // TODO: This will have to be elaborated ...
    return of(true);
  } else {
    return authService
      .isAuthenticated$()
      ?.pipe(
        switchMap((isAuthenticated) =>
          isAuthenticated
            ? of(true)
            : authService.connectOAuth(false, state.url),
        ),
      );
  }
};
